// Turbolinks はページのスナップショットをキャッシュし、戻る操作やプレビュー表示で復元する。
// reCAPTCHA のウィジェットが描画済みの状態でキャッシュされると、復元後に body の script が
// 再実行されて空でない placeholder に render しようとし
// 「reCAPTCHA placeholder element must be empty」で落ちる。キャッシュ前に中身を空へ戻す。
// このイベントの直後に body ごと差し替わるため、表示中の DOM を空にしても画面には出ない。
document.addEventListener('turbolinks:before-cache', () => {
  document.querySelectorAll('.g-recaptcha').forEach((placeholder) => {
    placeholder.replaceChildren();
  });
});
